// The social assistant's sign-up intent. See utils/signupIntent and SignupSourceIntent.
import { recordSignupIntent, clearSignupIntent } from './signupIntent'

export const SOCIAL_ASSISTANT_START_PATH = '/social-assistant/start'
const INTENT_PATH = '/social-assistant/intent'

export const recordSocialAssistantIntent = () => recordSignupIntent(INTENT_PATH)
export const clearSocialAssistantIntent = () => clearSignupIntent(INTENT_PATH)
